export default new class Menu {
	init() {
		this.initAsideMenu();
    }

	initAsideMenu() {
		if(document.querySelector('.js-burger')) {
			const burger = document.querySelector(".js-burger");
			const header = document.querySelector(".js-header");
			const asideMenu = document.querySelector(".js-aside-menu");

			burger.addEventListener('click', () => {	
				burger.classList.toggle("open");
				header.classList.toggle("aside-menu-open");
				asideMenu.classList.toggle("aside-menu-open");
			});
		}
	}
}